<template>
  <div class="left_slide" :style="{ left: isup ? '-134px' : 0 }">
    <ul class="left_slide_list">
      <li class="slide_item" @click="toLive800">
        <img src="../assets/slide/slide_1.png" alt="" />
        预约试听
      </li>
      <li class="slide_item" @click="toLive800">
        <img src="../assets/slide/slide_2.png" alt="" />
        考试咨询
      </li>
      <li class="slide_item" @click="toLive800">
        <img src="../assets/slide/slide_3.png" alt="" />
        语言测试
      </li>
      <li class="slide_item" @click="toLive800">
        <img src="../assets/slide/slide_4.png" alt="" />
        学习规划
      </li>
      <li class="slide_item" @click="toLive800">
        <img src="../assets/slide/slide_5.png" alt="" />
        备考工具
      </li>
      <li class="slide_item" @click="toLive800">
        <img src="../assets/slide/slide_6.png" alt="" />
        考试资料
      </li>
      <li class="slide_item">
        <img src="../assets/slide/slide_7.png" alt="" />
        400-002-2508
      </li>
      <li class="slide_item">
        <img src="../assets/slide/slide_8.png" alt="" />
        微信客服
      </li>
      <li class="slide_item" @click="backTop">
        <img src="../assets/slide/slide_9.png" alt="" />
        返回顶部
      </li>
    </ul>
    <img src="../assets/slide/slide_11.png" class="left_slide_tag" alt="" />
    <img
      src="../assets/slide/slide_10.png"
      @click="isup = !isup"
      class="operate_btn"
      alt=""
    />
  </div>
</template>
  <script>
export default {
  components: {},
  data() {
    return {
      isup: false,
    };
  },

  methods: {
    toLive800() {
      window.open(
        "https://live800.eiceducation.com.cn/live800/chatClient/chatbox.jsp?companyID=8940&configID=50&enterurl=https%3A%2F%2Fonline.eickaopei.com%2Fspecial%2Fielts_online%2F%3Faccount%3Donline%26medium%3Dkp_wk_pc_baidu_cpc%26campaign%3DWK-%25E9%259B%2585%25E6%2580%259D-%25E5%259F%25B9%25E8%25AE%25ADPC%26content%3DYS-%25E5%2588%2586%25E6%2595%25B0-%25E5%25AD%25A6%25E6%25A0%25A11%26kwd%3D%25E9%259B%2585%25E6%2580%259D%25E6%259C%25BA%25E6%259E%25848%25E5%2588%2586%26medium%3Dkp_wk_pc_baidu_cpc&remark=param1%3D17E200E860DA4DD29B95187249BBB63D%26param3%3D3E5809FD16724B53B77B50E55AB0AE05%26param4%3Dnewkaopei"
      );
    },
    backTop() {
      document.getElementById("app").scrollIntoView({
        behavior: "smooth", // 平滑过渡
        block: "start", // 上边框与视窗顶部平齐。默认值
      });
    },
  },
};
</script>
  
  <style scoped lang="less">
.left_slide {
  position: fixed;
  top: 80px;
  z-index: 999;
  display: flex;
  align-items: center;
  transition: all 0.4s;
  .left_slide_tag {
    position: absolute;
    top: 0;
    right: 32px;
  }
  .left_slide_list {
    width: 134px;
    overflow: hidden;
    padding: 6px 0;
    background-color: #fff;
    background: #ffffff;
    box-shadow: 6px 6px 7px 0px rgba(167, 167, 167, 0.5);
    border-radius: 0px 12px 12px 0px;
    display: flex;
    align-items: center;
    flex-direction: column;
    .slide_item {
      cursor: pointer;
      padding: 8px 0 9px;
      position: relative;
      display: flex;
      align-items: center;
      flex-direction: column;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: #333300;
      line-height: 20px;
      img {
        margin-bottom: 4px;
      }
      &::after {
        content: "";
        width: 80px;
        height: 1px;
        background: #e1e1e1;
        border-radius: 2px;
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
      }
      &:last-of-type {
        &::after {
          content: "";
          width: 80px;
          height: 0;
        }
      }
    }
  }
  .operate_btn {
    width: 33px;
    height: 160px;
    cursor: pointer;
  }
}
</style>
  


// WEBPACK FOOTER //
// src/components/left_slide.vue